const PREFIX = 'AUTH'

export const AUTH_GOOGLE_PROFILE_GET = `${PREFIX}_GOOGLE_PROFILE_GET`
export const AUTH_GOOGLE_PROFILE_GET_ERROR = `${PREFIX}_GOOGLE_PROFILE_GET_ERROR`

export const AUTH_LOG_IN_ERRORS = `${PREFIX}_LOG_IN_ERRORS`

export const AUTH_PROFILE_GET = `${PREFIX}_PROFILE_GET`
export const AUTH_PROFILE_GET_ERROR = `${PREFIX}_PROFILE_GET_ERRORS`

export const AUTH_PROFILE_UPDATE = `${PREFIX}_PROFILE_UPDATE`
export const AUTH_PROFILE_UPDATE_ERROR = `${PREFIX}_PROFILE_UPDATE_ERRORS`
export const AUTH_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`

export const AUTH_GET_CATEGORIES_LOG_IN = `${PREFIX}_CATEGORIES_LOG_IN`
export const AUTH_GET_CATEGORIES_REGISTER = `${PREFIX}_CATEGORIES_REGISTER`
export const AUTH_GET_CATEGORIES_LOADING = `${PREFIX}_CATEGORIES_LOADING`

export const AUTH_CLEAR_CATEGORIES = `${PREFIX}_CLEAR_CATEGORIES`

export const AUTH_MAP_REGISTER = `${PREFIX}_MAP_REGISTER`

export const AUTH_PROFILE_SETTINGS = `${PREFIX}_PROFILE_SETTINGS`
export const AUTH_PROFILE_SETTINGS_ERROR = `${PREFIX}_PROFILE_SETTINGS_ERROR`
export const AUTH_PROFILE_SETTINGS_LOADING = `${PREFIX}_PROFILE_SETTINGS_LOADING`

export const AUTH_PROFILE_SECTION = `${PREFIX}_PROFILE_SECTION`
export const AUTH_PROFILE_SECTION_ERROR = `${PREFIX}_PROFILE_SECTION_ERROR`
export const AUTH_PROFILE_SECTION_LOADING = `${PREFIX}_PROFILE_SECTION_LOADING`
export const AUTH_PROFILE_SECTION_CLEAR = `${PREFIX}_PROFILE_SECTION_CLEAR`

export const AUTH_CHANGE_PASSWORD_ERROR = `${PREFIX}_CHANGE_PASSWORD_ERROR`
export const AUTH_LOGOUT_ERRORS = `${PREFIX}_LOGOUT_ERRORS`
